var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collapsible" }, [
    _c(
      "div",
      { staticClass: "row collapsible__header", on: { click: _vm.invert } },
      [
        _c("div", {
          class:
            "col-xs-1 collapsible__slider " +
            (_vm.show ? "collapsible__slider--collapsed" : "")
        }),
        _vm._v(" "),
        _c("h4", { staticClass: "col-xs collapsible__header-text" }, [
          _vm._v(_vm._s(_vm.title))
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "row collapsible__content" }, [
      _c(
        "div",
        { staticClass: "col-xs col-xs-offset-1 collapsible__content-text" },
        [_vm.show ? _vm._t("default") : _vm._e()],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31aec6e6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31aec6e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./www/js/Components/CollapsibleBlock/CollapsibleBlock.vue
// module id = 515
// module chunks = 0